import React, { useCallback, useContext } from 'react';
import { action, get, set } from 'mobx';
import { observer } from 'mobx-react-lite';
import { pxToRem } from '../../../es/_util/UnitConvertor';
import ResizeObservedRow from './ResizeObservedRow';
import TableContext from './TableContext';
import { isStickySupport } from './utils';
const TableHeaderRow = observer(function TableHeaderRow(props) {
    const { rowIndex, lock, children, rows } = props;
    const { rowHeight, tableStore } = useContext(TableContext);
    const setRowHeight = useCallback(action((index, height) => {
        set(tableStore.lockColumnsHeadRowsHeight, index, height);
    }), [tableStore]);
    const getRowHeight = (index) => {
        return get(tableStore.lockColumnsHeadRowsHeight, index) || 0;
    };
    const getHeaderRowStyle = () => {
        const height = getRowHeight(rowIndex);
        return pxToRem(rows
            .slice(rowIndex + 1)
            .reduce((total, r, index) => r.length
            ? total
            : total +
                getRowHeight(index + rowIndex + 1), height));
    };
    const needStoreRowHeight = !isStickySupport() && (rowHeight === 'auto' || rows.length > 1);
    const style = lock && needStoreRowHeight ? {
        height: getHeaderRowStyle(),
    } : undefined;
    const tr = (React.createElement("tr", { style: style }, children));
    return !lock && needStoreRowHeight ? (React.createElement(ResizeObservedRow, { onResize: setRowHeight, rowIndex: rowIndex }, tr)) : tr;
});
TableHeaderRow.displayName = 'TableHeaderRow';
export default TableHeaderRow;
